import MovesCompletedProgress from './MovesCompletedProgress'

export default MovesCompletedProgress
